import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { notifyModalOpen, notifyModalClose } from '../utils/modalState';

interface ModalPortalProps {
  children: React.ReactNode;
  onClose: () => void;
}

const ModalPortal: React.FC<ModalPortalProps> = ({ children, onClose }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    document.body.style.overflow = 'hidden';
    notifyModalOpen();

    return () => {
      setMounted(false);
      document.body.style.overflow = 'unset';
      notifyModalClose();
    };
  }, []);

  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  if (!mounted) return null;

  return createPortal(
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh'
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default ModalPortal; 